// extracted by mini-css-extract-plugin
module.exports = {"root":"cart-empty_root__2QxaO","title":"cart-empty_title__2Yul2","content":"cart-empty_content__TiZJ_"};